import React, { FC, useCallback } from 'react';
import styles from '../index.module.scss';
import { Radio, Spin } from 'src/common';
import { SearchProfilesColorsDict, SearchProfileColor } from 'src/helpers/constants';
import { useTranslation } from 'react-i18next';
import { RadioChangeEvent } from 'antd/lib/radio';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { useUnusedColors } from 'src/pages/TenderPage/DocumentSearch/hooks';

interface IProps {
  onUpdate: (color: SearchProfileColor) => void;
  currentColor: SearchProfileColor;
}

export const ColorPickerOverlay: FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();
  const { onUpdate, currentColor } = props;

  const onChooseColor = useCallback(
    (e: RadioChangeEvent): void => {
      const { value } = e.target;
      onUpdate(value);
    },
    [onUpdate]
  );

  const { data: unusedColors, loading } = useUnusedColors(currentColor);

  return (
    <div className={styles.dropdown}>
      <div className={styles.dropdownTitle}>
        <span>{t('Common.selectColor')}</span> {loading && <Spin size="small" />}
      </div>
      {!loading && (
        <div className={styles.dropdownInner}>
          <Radio.Group onChange={onChooseColor} defaultValue={currentColor}>
            {unusedColors.map(color => (
              <Radio.Button
                key={`color_${color}`}
                value={color}
                className={styles.radioButton}
                style={{ color: SearchProfilesColorsDict[color] }}
              >
                <div className={styles.radioIcon}>
                  <FontAwesomeIcon icon={faCheck} />
                </div>
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
      )}
    </div>
  );
};

export default ColorPickerOverlay;
